export default (defaultLanguage = 'en', languages = {}) => ({
    currentLanguage: defaultLanguage,
    languages: languages,

    switchTo(language) {
        this.currentLanguage = language;
        this.$dispatch('form-language-changed', { language });
    },

    isActive(language) {
        return this.currentLanguage === language;
    },

    handleChangedLanguage(event) {
        this.currentLanguage = event.detail.language;
    }
});